<template>
    <div class="app-search">
        <h4 class="title">Search Apps</h4>
        <div class="search-container">
            <qw-input name="search"
                icon="fas fa-search"
                type="text"
                placeholder="Start typing here..."
                :autocomplete=false
                v-model="searchQuery"
            ></qw-input>
            <div class="data-list">
                <template v-if="status === 'ready'">
                    <app-router-link class="list-item" :url="app.Url" :app-id="app.Id" :app-name="__('Name', app)" v-for="app in apps" :key="app.Id">
                        <span class="text">{{ __("Name", app) }}</span>
                    </app-router-link> 
                </template>
                <p class="list-item loading" v-if="status === 'loading'"><i class="fas fa-circle-notch fa-spin"></i>Loading...</p>
                <p class="list-item retry" v-if="status === 'error'"><i class="fas fa-exclamation-triangle"></i>Please try again.</p>
            </div>
        </div>
    </div>    
</template>

<script>
import QwInput from "@/components/global/form/QWInput";
import AppRouterLink from "@/components/AppRouterLink";
import ApplicationService from "@/services/ApplicationService";

export default {
    name: "app-search",
    components: {
        QwInput,
        AppRouterLink,
    },
    data() {
        return {
            status: "ready",
            searchQuery: "",
            apps: [],
        }
    },
    methods: {
        async search() {
            this.status = "loading";
            try {
                let response = await ApplicationService.searchApplications(this.searchQuery);
                this.apps = response.data;
                this.status = "ready";
            } catch(e) {
                this.apps = [];
                this.status = "error";
            }
        }
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        }
    },
    watch: {
        searchQuery() {
            if(this.searchQuery.length)
                this.search();
            else
                this.apps = [];
        }
    }
}
</script>

<style lang="scss">
.app-search {
    padding: 0 $sidebar-padding;
    .title {
        margin: 0 0 7px 0;
        padding: 0;
        font-family: $raleway;
        font-size: 13px;
        font-weight: 700;
        text-transform: uppercase;
        color: $light-blue;
    }
    .search-container {
        position: relative;
        .qw-input {
            .qw-input-field {
                padding: 4px 15px;
                font-size: 14px;
                .icon {
                    margin: 0 10px 0 0;
                }
            }
        }
        .data-list {
            position: absolute;
            top: calc(100% + 3px);
            background: none;
            width: 100%;
            z-index: 1000;
            .list-item {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
                padding: 8px 10px;
                background-color: $lighter-gray;
                cursor: pointer;
                @include removeBootstrapOutline;
                @include fastestTransition;
                border-bottom: 1px solid $light-gray!important;
                .text {
                    text-align: left;
                    font-size: 13px;
                    font-family: $lato;
                    font-weight: 400;
                    color: $text-color;
                }
                &.loading, &.retry {
                    font-size: 14px;
                    margin: 0;
                    i {
                        margin: 0px 10px 0px 0px;
                    }
                }
                &:hover {
                    background-color: $light-gray;
                }
                &:last-child {
                    border-bottom: none!important;
                }
            }
        }
    }
}

@media screen and (max-width: $breakpoint-sm) {
    .app-search {
        .qw-input {
            .qw-input-field {
                font-size: 12px;
            }
        }
        .data-list {
            .list-item {
                .text {
                    font-size: 12px!important;
                }
            }
        }
    }
}

.dark {
    .app-search {
        .title {
            color: $darker-gray;
        }
        .app-search-container {
            .data-list {
                .list-item {
                    background-color: $darkest-gray;
                    border-bottom: 1px solid $extra-dark-gray!important;
                    .text {
                        color: $gray;
                    }
                    &:hover {
                        background-color: $extra-dark-gray;
                    }
                }
            }
        }
    }
}
</style>
